import React from 'react';
import Form from './Form';

class BezpMail extends React.Component {
    render() {
        return(
        <div className="problem bezp-mail">
            <div className="content shadow-box">
                <p>Tu możesz wysłać mail do klienta, którego adres mailowy jest Ci znany i pobrać od niego płatność za usługę.</p>
                <p>Klient otrzyma Twój mail wraz z linkiem umożliwiającym wykonanie natychmiastowej płatności za usługę (z wykorzystaniem serwisu płatności Przelewy24).</p>
                <p>Natychmiast po wniesieniu płatnosci przez klienta otrzymasz mail z powiadomieniem o zapłacie i możesz przystąpić do wykonania zadania.</p>
                <p>Zapłata zostanie zapisana w Twoim portfelu w serwisie specprawnik. W dowolnej chwili możesz ją przelac na swoje konto.</p>
                <Form />
            </div>
        </div>
        )
    }
}

export default BezpMail;